// Components==============
import AudioTypingExercise from 'components/Exercises/AudioTypingExercise/AudioTypingExercise';
import ClapSoundExercise from 'components/Exercises/ClapSoundExercise/ClapSoundExercise';
import FindWrongExercise from 'components/Exercises/FindWrongExercise/FindWrongExercise';
import React, { useContext } from 'react';
import { AudioExerciseContext } from '../AudioExercise';
// =========================

export default function ConditionalExercise() {
    const { exercise } = useContext(AudioExerciseContext);

    if (exercise?.type === 'clap_sound' || exercise?.type === 'clap_word')
        return <ClapSoundExercise />;

    if (exercise?.type === 'find_wrong') return <FindWrongExercise />;

    if (exercise?.type === '4-7') return <AudioTypingExercise />;

    return <></>;
}
